/* eslint-disable react/prop-types */
import { dateTimeZoneConverter } from "../../../../../../../../../utils/commonFunctions/date";
import "./termsConditions.css";
import { Grid } from "@material-ui/core";
import { TermsConditionProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/prop-types
const TermsCondition = ({ isPrintable, employee, enrollmentDate }: TermsConditionProps) => {
	const { first_name, last_name } = employee;
	if (!first_name && !last_name) return <></>;
	return (
		<div className="gli-terms">
			<div className={isPrintable ? "" : "gli-terms-header-space"}>
				<p
					className={isPrintable ? "beneficary-paragraph font-size-medium" : "beneficary-paragraph"}
					style={{ textAlign: "justify" }}
				>
					*If more than one primary beneficiary is named, the primary beneficiaries shall share equally unless
					otherwise indicated above. <br /> **Contingent Beneficiary(ies) will only receive proceeds if all
					Primary Beneficiaries have predeceased the Insured. If you are naming more than one Contingent
					Beneficiary at 100% each, please indicate 1st contingent, 2nd contingent, 3rd contingent, etc. in
					the order of precedence. <br /> <br />
					<p
						className={
							isPrintable ? "beneficary-paragraph-highlight-print" : "beneficary-paragraph-highlight"
						}
						style={{ fontSize: "1em" }}
					>
						SPOUSAL CONSENT FOR COMMUNITY PROPERTY STATES ONLY**. See Conditions on reverse side of form.
					</p>
					<b>
						***Please note that an employee is under no obligation to complete the Spousal Consent section
						of this form.
					</b>
				</p>
			</div>
			<div className={isPrintable ? "gli-terms-header-space-print" : "gli-terms-header-space"}>
				<Grid container spacing={1}>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						className={isPrintable ? "gli-terms-container-print" : "gli-terms-container"}
					>
						<div className={isPrintable ? "gli-terms-paragraph font-size-md" : "gli-terms-paragraph"}>
							I am aware that my spouse, the Employee named above, has designated someone other than me to
							be the beneficiary of group life insurance under the above policy. I hereby consent to such
							designation and waive any rights I may have to the proceeds of such insurance under appli-
							cable community property laws. I understand that this consent and waiver supersedes any
							prior spousal consent or waiver under the plan.
						</div>
						<div
							className={isPrintable ? "gli-terms-footer-container-print" : "gli-terms-footer-container"}
						>
							<div className="gli-terms-signature-container">
								<div className="gli-textfield-container">
									<input
										type="text"
										className={
											isPrintable
												? "signature-container-print font-size-sm"
												: "signature-container"
										}
										size={isPrintable ? 50 : 80}
										disabled={true}
									/>
								</div>
								<div className={isPrintable ? "helper-text font-size-sm" : "helper-text"}>
									Signature of Spouse
								</div>
							</div>
							<div className="gli-terms-date-container">
								<input
									type="text"
									className={
										isPrintable ? "date-label-container-print font-size-sm" : "date-label-container"
									}
									size={isPrintable ? 25 : 40}
									disabled={true}
								/>
								<div className={isPrintable ? "helper-text-date font-size-sm" : "helper-text-date"}>
									Date
								</div>
							</div>
						</div>
					</Grid>
				</Grid>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="gli-footer-emplyoee-signature">
						<div className="gli-terms-footer-container">
							<div className="gli-terms-footer-signature-container">
								<div className="gli-textfield-container">
									<div
										className={
											isPrintable
												? "signature-value font-size-sm"
												: "signature-value font-size-large"
										}
									>
										<span>{first_name}</span>
										<span style={{ marginLeft: "2px" }}>{last_name}</span>
									</div>
								</div>
								<div className="bottom-border"></div>
								<div
									className={
										isPrintable ? "helper-text font-size-sm" : "helper-text font-size-medium"
									}
								>
									<b>Signature of Emplyoee</b>
								</div>
							</div>
							<div className="gli-terms-footer-date-container">
								<div
									className={
										isPrintable ? "date-value font-size-small" : "date-value font-size-large"
									}
								>
									{String(dateTimeZoneConverter(String(enrollmentDate)))}
								</div>
								<div className="bottom-border"></div>
								<div
									className={
										isPrintable
											? "helper-text-date font-size-small"
											: "helper-text-date font-size-medium"
									}
								>
									<b> Date</b>
								</div>
							</div>
						</div>
					</Grid>
				</Grid>
			</div>
			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} lg={12} md={12} xl={12}>
					<div className={isPrintable ? "gli-form-footer margin-top-1" : "gli-form-footer margin-top-5"}>
						<div>
							<div className="gli-form-footer-text font-size-sm">95436</div>
							{/* <div className="gli-form-footer-text font-size-sm">
								Lincoln Financial Group is the marketing name for Lincoln National Corporation and its
								affiliates.
							</div>
							<div className="gli-form-footer-flex">
								<div className="gli-footer-content1 font-size-sm">GLC-02170 </div>
								<div className="gli-footer-content2 font-size-sm">BNFCRYINF</div>
							</div> */}
						</div>
						<div className="gli-form-footer-page">
							<div className="gli-footer-page1 font-size-sm">Rev. 1/18</div>
							{/* <div className="gli-footer-page1 font-size-sm">Page 1 of 2</div>
							<div className="gli-footer-pgae2 font-size-sm">5/17</div> */}
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default TermsCondition;
